import React from "react";
import { GithubPicker } from "react-color";
import styled from "styled-components";

const Element = styled.div`
  margin-left: 16px;
  margin-right: 16px;

  > div.upper {
    color: white;
  }
`;

const Wrapper = styled.div`
  flex-wrap: wrap;
`;

import colorsArray from "../data/colorsArray.json";

import ReactFontPicker from "./ReactFontPicker";

export default function TextBearbeitung(props) {
  let colors;
  if (props.folienTyp === "Hochwertig") {
    colors = [
      "#F48418",
      "#FB9301",
      "#FD9B0B",
      "#E4860D",
      "#D1850A",
      "#F4A002",
      "#FDA617",
      "#F8AF0A",
      "#FABE09",
      "#FFE934",
      "#69000F",
      "#8E0E01",
      "#970005",
      "#990B07",
      "#CD0001",
      "#C90E08",
      "#C60205",
      "#D40606",
      "#D20301",
      "#E40A03",
      "#D20300",
      "#D90D07",
      "#DD1603",
      "#F02603",
      "#F02505",
      "#F93E15",
      "#F22E0C",
      "#F74B04",
      "#E93800",
      "#480019",
      "#7E0307",
      "#581045",
      "#44184C",
      "#3B266E",
      "#655194",
      "#B88CB3",
      "#C50B49",
      "#C81356",
      "#D6396C",
      "#EF67A7",
      "#111823",
      "#001836",
      "#0B1536",
      "#0D173C",
      "#002258",
      "#132E5B",
      "#002B6E",
      "#01155B",
      "#051F6E",
      "#032070",
      "#0E237D",
      "#001771",
      "#032799",
      "#011E7C",
      "#003773",
      "#014A6D",
      "#003687",
      "#00489A",
      "#003789",
      "#004E9A",
      "#015BB8",
      "#0053AC",
      "#2F70B9",
      "#026EAD",
      "#0173BC",
      "#0083C8",
      "#1FA6DD",
      "#65879A",
      "#004E72",
      "#01779B",
      "#0093A7",
      "#14C7C6",
      "#68D3E7",
      "#003E23",
      "#004229",
      "#004517",
      "#00541D",
      "#016753",
      "#01703D",
      "#00753F",
      "#007A42",
      "#018454",
      "#008C3C",
      "#009B1B",
      "#4A9D36",
      "#45291E",
      "#422516",
      "#4F331F",
      "#52020E",
      "#B44C17",
      "#6E3510",
      "#9A683F",
      "#9E755A",
      "#DCAE8C",
      "#E4C194",
      "#FAD3A8",
      "#E9D7BD",
      "#ECD8BF",
      "#000000",
      "#2E2F31",
      "#373C3F",
      "#595E61",
      "#616F70",
      "#75828A",
      "#85898C",
      "#8A8F8C",
      "#97999B",
      "#C5C8CB",
      "#DCE2E9",
      "#FFFFFF",
      "#838180",
      "#885D3C",
      "#292F2C",
      "#2D3138",
    ];
  } else if (props.folienTyp === "MattPremium") {
    colors = ["#FFFFFF", "#000000"];
  } else if (props.folienTyp === "Milchglas") {
    colors = ["#EDECEC", "#D2CFCF"];
  } else {
    colors = [
      "#000000",
      "#FFFFFF",
      "#F48418",
      "#E8A908",
      "#FCC517",
      "#F8B725",
      "#F1E702",
      "#69000F",
      "#7F0400",
      "#A50409",
      "#CD0102",
      "#D72428",
      "#E41C05",
      "#DC4824",
      "#FA4019",
      "#441853",
      "#685292",
      "#B48FBD",
      "#EC2676",
      "#EA80B3",
      "#141E3A",
      "#16143A",
      "#0D264F",
      "#032070",
      "#032799",
      "#003575",
      "#023382",
      "#003D83",
      "#014A99",
      "#0055A2",
      "#006BB9",
      "#0083C8",
      "#1FA6DD",
      "#01779B",
      "#0093A7",
      "#14C7C6",
      "#0E3F2C",
      "#024A35",
      "#017246",
      "#00763F",
      "#028542",
      "#0C9016",
      "#69BD47",
      "#45291D",
      "#B85C27",
      "#C7763F",
      "#AC885F",
      "#C7B69F",
      "#FCD9AB",
      "#373C3F",
      "#616F70",
      "#707D80",
      "#7C8486",
      "#BEC2C7",
      "#828688",
      "#866C2C",
      "#7F3D21",
    ];
  }

  return (
    <Wrapper className="flex">
      <Element className="element">
        <div className="upper">Zeile</div>
        <div className="lower">
          <select
            id="zeile"
            onChange={(e) => {
              props.setAktiveZeile(e.target.value);
            }}
          >
            <option value={0}>Alle</option>
            {props.zeilen.map((item, key) => {
              return (
                <option key={key} value={item}>
                  {item}
                </option>
              );
            })}
          </select>
        </div>
      </Element>
      <Element className="element">
        <div className="upper">Schriftart</div>
        <div className="lower">
          <ReactFontPicker
            reactFontPicker={props.reactFontPicker}
            font={props.fullInfo[props.aktiveZeile - 1].font}
          />
        </div>
      </Element>
      <Element className="element">
        <div className="upper">Farben</div>
        <div className="lower absolute">
          <div
            className="color-picker-mk"
            onClick={props.toggleColorModal}
            style={{
              backgroundColor: props.hexcode,
            }}
          ></div>
          {props.colorModalIsShown ? (
            <div className="color-picker-wrapper-mk">
              {colorsArray
                ?.filter((c) => colors.includes(c.hexcode))
                .map((color, index) => {
                  return (
                    <div
                      onClick={() => props.colorClicked(color.hexcode)}
                      id={index}
                      key={index}
                      className="color-modal-mk"
                      style={{
                        backgroundColor: color.hexcode,
                        color: color.complementaryColor,
                      }}
                    >
                      {color.name}
                    </div>
                  );
                })}
            </div>
          ) : null}
        </div>
      </Element>
      <Element className="element">
        <div className="upper">Schriftgröße</div>
        <div className="lower">
          <select
            id="schriftgroesse"
            value={
              props.fullInfo[props.aktiveZeile - 1].fontSize.includes("px")
                ? props.fullInfo[props.aktiveZeile - 1].fontSize
                : props.fullInfo[props.aktiveZeile - 1].fontSize + "px"
            }
            onChange={(e) => {
              props.setFontSize(e);
            }}
          >
            <option value="16px">1</option>
            <option value="18px">2</option>
            <option value="20px">3</option>
            <option value="22px">4</option>
            <option value="24px">5</option>
            <option value="26px">6</option>
            <option value="28px">7</option>
            <option value="32px">8</option>
            <option value="36px">9</option>
            <option value="40px">10</option>
            <option value="44px">11</option>
            <option value="48px">12</option>
          </select>
        </div>
      </Element>
      <Element className="element">
        <div className="upper">Ausrichtung</div>
        <div className="lower">
          <div
            className="active left text-align-logo mk-left"
            onClick={props.setTextAlign}
          ></div>
          <div
            className="center text-align-logo mk-center"
            onClick={props.setTextAlign}
          ></div>
          <div
            className="right text-align-logo mk-right"
            onClick={props.setTextAlign}
          ></div>
        </div>
      </Element>
      <Element className="element">
        <div className="upper">Zeilenabstand</div>
        <div className="lower">
          {/* <select
                        id="zeilenabstand"
                        value={props.zeilenabstand}
                        onChange={props.setLineHeight}
                    >
                        <option value="0.8em">1</option>
                        <option value="0.9em">2</option>
                        <option value="1em">3</option>
                        <option value="1.1em">4</option>
                    </select> */}
          <form>
            <input
              className="mk-input"
              type="number"
              id="hoehe"
              name="hoehe"
              onChange={props.setLineHeight}
              value={props.zeilenabstand}
              pattern="[0-9]+([\.,][0-9]+)?"
              step="1"
              min="1"
              max="10"
            ></input>
          </form>
        </div>
      </Element>

      <Element>
        <div className="upper">Zeichenabstand</div>
        <div className="lower">
          {/* <select
                        id="zeichenabstand"
                        value={
                            props.fullInfo[props.aktiveZeile - 1].letterSpacing
                        }
                        onChange={props.setLetterSpacing}
                    >
                        <option value="normal">1</option>
                        <option value=".2em">2</option>
                        <option value=".4em">3</option>
                        <option value=".6em">4</option>
                        <option value=".8em">5</option>
                        <option value="1.0em">6</option>
                    </select> */}
          <form>
            <input
              className="mk-input"
              type="number"
              id="hoehe"
              name="hoehe"
              onChange={props.setLetterSpacing}
              value={props.fullInfo[props.aktiveZeile - 1].letterSpacing}
              pattern="[0-9]+([\.,][0-9]+)?"
              step="1"
              min="-5"
              max="20"
            ></input>
          </form>
        </div>
      </Element>

      <Element className="element">
        <div className="upper">Spiegeln</div>
        <div className="lower">
          <input
            id="mirror-checkbox"
            className="mk-input"
            type="checkbox"
            onChange={props.toggleMirror}
          ></input>
        </div>
      </Element>
    </Wrapper>
  );
}
